<script setup lang="ts">
import { onBeforeMount, PropType, ref, Ref } from "vue";
import { useApiClient } from "@/api/client";
import { loadingWrapper } from "@/api/helpers/loadingWrapper";
import ModuleLoading from "@/ui/components/loading/moduleLoading.vue";
import PermissableManager from "@/ui/components/permissions/PermissableManagerTree.vue";
import { useRoute } from "vue-router";

const props = defineProps({
	user: {
		type: Object as PropType<App.Data.UserDO>,
		require: true,
	},
});

// Emit is not used in this component but required through the tabs-router-view setup.
const emit = defineEmits(["update-user"]);

const emptyUpdatePermission = () => {
	return async () => {};
};
</script>

<template>
	<module-loading>
		<v-alert
			class="mt-5"
			border="start"
			variant="tonal"
			close-label="Close Alert"
			color="warning"
			:title="$t('users.permissions.warningTitle')"
		>
			{{ $t("users.permissions.warningText") }}
		</v-alert>
		<v-card class="mt-5 pa-3">
			<permissable-manager
				:async-update-function="() => {}"
				:derived-permissions="user.derivedPermissions"
				:available-permissions="user.availablePermissions"
				:permission-lock-guard="user.lockoutGuardState"
				:read-only="true"
			/>
		</v-card>
	</module-loading>
</template>

<style lang="scss">
.v-expansion-panel-title__overlay {
	background: rgba(var(--v-theme-primary)) !important;
}
</style>
